import ocb from './onchainbarrel.png';
import bg from './bg.png';
import loading from './loading.gif'
import './App.css';
import React from "react";
//import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Row, Col, Image, Button, Alert, Form, Nav, Card} from 'react-bootstrap'
import {withRouter} from 'react-router';
import { Link, useLocation, BrowserRouter as Router } from "react-router-dom";
import ReactPlayer from 'react-player/lazy'
import screenfull from 'screenfull'

import * as Contracts from './blockchain/addresses.json'
import BABI from "./blockchain/bkabi.json";
import Web3 from 'web3'

const DEBUG = false

const BarrelsContract = DEBUG ? Contracts.rinkeby : Contracts.mainnet

  const { ethereum } = window
  
  class Barrels extends React.Component {
  
      constructor(props){
          super(props)
          this.state = {
            account:"",
            loading: true,
            userPieces:[],
            view: "main",
            minting: false,
            loggedin: false,
            tokens:[]
          }
          this.clickConnect = this.clickConnect.bind(this)
          this.handleNewAccounts = this.handleNewAccounts.bind(this)
          this.handleNetworkChange = this.handleNetworkChange.bind(this)
        }

        async claimBarrel(tokenid, index){
          console.log(tokenid + " " + index)
          var price = await this.state.contract.methods.price().call()
          console.log('price', price)
          let tokens = this.state.tokens

          this.setState({})
          await this.state.contract.methods.claimBarrel(tokenid).send({from: this.state.account, value: price})
          this.getWines()
        }

        async getWines(){
          console.log(this.state.contract)
          
          /*
          var web3 = new Web3(window.ethereum)
          var c = new web3.eth.Contract(BABI, BarrelsContract)
          this.setState({web3: web3 , loading:false, connected:true, contract: c})
          */

          const url = 'https://api.opensea.io/api/v1/assets?owner='+this.state.account+'&order_direction=desc&offset=0&limit=50&collection=onchain-wine';
          const options = {method: 'GET'};

          fetch(url, options)
            .then(res => res.json())
            .then(async (json) => {
             // console.log(json)
              let tokens = []

              for(var i = 0; i < json.assets.length; i++){
                console.log(json.assets[i].token_id)
                tokens.push({image: json.assets[i].image_url, token:json.assets[i].token_id, claimed: await this.state.contract.methods.wineClaimed(json.assets[i].token_id).call()})
              }
              this.setState({tokens: tokens})
              console.log(tokens)
            })
            .catch(err => console.error('error:' + err));


        }
      
        async clickConnect(){
          await this.initializeMetamask()
        }
      
        handleNewAccounts(newAccounts) {
          if(!newAccounts){
            this.setState({account:""})
          }
          else{
            this.setState({account:newAccounts[0]})
          }
          //window.location.reload()
        }
    
        handleNetworkChange (networkId) {
          console.log(networkId)
          this.setState({network:networkId})
        }
      
      async checkWeb3(){

      }

      async changeView(view){
        this.setState({view: view})
      }
  
      async initializeMetamask(){
          if (ethereum) {
            await window.ethereum.enable();
            ethereum.autoRefreshOnNetworkChange = true
      
            ethereum.on('accountsChanged', (accounts)=> this.handleNewAccounts(accounts[0]))
            ethereum.on('chainChanged', (_chainId) => this.handleNetworkChange(_chainId));
            const accounts = await ethereum.request({ method: 'eth_accounts' });
            this.setState({account: accounts[0]})
            this.getWines()
          }
        }
      
        async componentDidMount() {
          if (navigator.platform.indexOf("Win") > -1) {
          }
          if(ethereum){
            console.log("yes eth")
            //this.initializeMetamask()
            var web3 = new Web3(window.ethereum)
            var c = new web3.eth.Contract(BABI, BarrelsContract)
            var claimable = await c.methods.claimActive().call()
            this.setState({web3: web3 , loading:false, connected:true, contract: c, claimable: claimable})
          }
          else{
            this.setState({web3:false, loading: false})
          }
       
        }
  
  render(){

    switch(this.state.view){
      case 'main':
        return(
   
<div>


  <Row   style={{backgroundImage: 'url("'+bg+'")'}}>
        <Col md={6} style={{padding:'5%', textAlign:'center', minHeight: '1000px'}}>
        </Col>
        <Col md={6} style={{padding:"5%", textAlign:'center'}} >
          <div style={{backgroundColor:'#ffffff', padding: '10%'}}>
          <h2>Welcome to The Cellar!</h2><br/>
          <p>Here, connoisseurs like yourself can venture down the storied, stonework stairwells into our underground aging rooms.<br/><br/>
             Contained within is a cache of 1,000 barrels, each an original work from artist HirotoKai, reserved exclusively for OnChain Wine holders. 
             <br/><br/>Each wine allows its collector to mint a randomly selected barrel from The Cellar for .01 Ξ (+gas). 
             <br/><br/><strong>Thats right, 1 wine = 1 barrel… and each wine can only be claimed once!</strong></p><br/><br/><br/>
        <h2>Your OnChain Wines</h2><br/>
        { this.state.account == "" ? 

        <Button variant="danger" onClick={()=>{this.clickConnect()}}>Connect Wallet</Button>

          :

        <div>
          <Row>
          {!this.state.claimable ? 

          <Col><Button variant="danger" disabled>Claiming not active</Button></Col>
          :

          this.state.tokens.map((item, index) => (
                        <Col key={index}>
                        <img src={item.image} style={{width:150}}  className="img-fluid"></img><br/>
                        
                        
                        
                        {item.claimed ? 
                        <Button variant="info" onClick={()=>{this.claimBarrel(item.token, index)}} disabled>Already Claimed</Button>
                      :
                        
                        <Button variant="danger" onClick={()=>{this.claimBarrel(item.token, index)}}>Claim Barrel</Button>

                              }
                        </Col>
          ))
          }
          </Row>
        </div>
    }
    </div>
        </Col>
      </Row>
      </div>
)
        break;
    }
  }
}

export default withRouter(Barrels);
